<template>
    <div class="board">
        <div class="bar">
            <b-icon icon="journal-text" class="icon"></b-icon>
            <span>ข้อมูลรถ</span>
        </div>
        
        <div class="content">
            <div class="form" v-if="contentData">
                <div class="row">
                    <div class="col-md-12 col-lg-6 col-xl-4">
                        <div class="row">
                            <div class="col-md-12 col-lg-4">
                                <label class="inline-label">เลขทะเบียน</label>
                            </div>
                            <div class="col-md-12 col-lg-7">
                                <div class="field">
                                    <input type="text" :value="contentData.licensePlate" class="input-field reader" readonly />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12 col-lg-6 col-xl-4">
                        <div class="row">
                            <div class="col-md-12 col-lg-4">
                                <label class="inline-label">ทะเบียนจังหวัด</label>
                            </div>
                            <div class="col-md-12 col-lg-7">
                                <div class="field">
                                    <input type="text" :value="contentData.licensePlateProvince" class="input-field reader" readonly />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12 col-lg-6 col-xl-4">
                        <div class="row">
                            <div class="col-md-12 col-lg-4">
                                <label class="inline-label">เลขไมล์ล่าสุด</label>
                            </div>
                            <div class="col-md-12 col-lg-7">
                                <div class="field">
                                    <input type="text" :value="contentData.latestRunningDistance" class="input-field reader" readonly />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-12 col-lg-6 col-xl-4">
                        <div class="row">
                            <div class="col-md-12 col-lg-4">
                                <label class="inline-label">ยี่ห้อรถ</label>
                            </div>
                            <div class="col-md-12 col-lg-7">
                                <div class="field">
                                    <input type="text" :value="contentData.carBrand" class="input-field reader" readonly />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12 col-lg-6 col-xl-4">
                        <div class="row">
                            <div class="col-md-12 col-lg-4">
                                <label class="inline-label">รุ่นรถ</label>
                            </div>
                            <div class="col-md-12 col-lg-7">
                                <div class="field">
                                    <input type="text" :value="contentData.carModel" class="input-field reader" readonly />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12 col-lg-6 col-xl-4">
                        <div class="row">
                            <div class="col-md-12 col-lg-4">
                                <label class="inline-label">ปีรถ</label>
                            </div>
                            <div class="col-md-12 col-lg-7">
                                <div class="field">
                                    <input type="text" :value="contentData.carYearSerie" class="input-field reader" readonly />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-12 col-lg-6 col-xl-4">
                        <div class="row">
                            <div class="col-md-12 col-lg-4">
                                <label class="inline-label">ผู้เข้ารับบริการล่าสุด</label>
                            </div>
                            <div class="col-md-12 col-lg-7">
                                <div class="field">
                                    <input type="text" :value="[ contentData.customerFirstName, contentData.customerLastName ].join(' ')" class="input-field reader" readonly />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12 col-lg-6 col-xl-4">
                        <div class="row">
                            <div class="col-md-12 col-lg-4">
                                <label class="inline-label">เบอร์ติดต่อล่าสุด</label>
                            </div>
                            <div class="col-md-12 col-lg-7">
                                <div class="field">
                                    <input type="text" :value="contentData.customerTel" class="input-field reader" readonly />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Helper from '@/resources/Helper';
import OptionLicensePlateProvince from '@/database/staticOption/LicensePlateProvince';
import DBCustomer from '@/database/Customer';

export default {
    data() {
        return {
            contentData: null
        };
    },
    async mounted() {
        this.contentData = await this.loadContentData();
    },
    methods: {
        async loadContentData() {
            const keyData = this.$route.params.key;
            let data = null;

            if (keyData) {
                data = await DBCustomer.getDetail(keyData);
            }

            if (data) {
                return this.mapViewData(data);
            } else {
                this.$router.push('/404');

                return null;
            }
        },
        mapViewData(data) {
            return {
                licensePlate: data.licensePlate,
                licensePlateProvince: OptionLicensePlateProvince.service.getValueByKey(data.licensePlateProvince),
                latestRunningDistance: Helper.getCommaNumber(data.latestRunningDistance),
                carBrand: data.carBrand,
                carModel: data.carModel,
                carYearSerie: data.carYearSerie,
                customerFirstName: data.customerFirstName,
                customerLastName: data.customerLastName,
                customerTel: data.customerTel
            }
        }
    }
}
</script>